var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightArabicLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 40,
    viewBox: "0 0 103 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3427 25.9796L87.5993 37.1478L86.5264 39.6672H86.531C88.4633 40.0562 90.4529 40.0592 92.4451 39.6735C93.9837 39.2865 95.4065 38.6707 96.673 37.8449C96.8327 37.7387 96.9878 37.6317 97.1424 37.5221L92.3427 25.9796Z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5391 30.8818C74.8342 31.2987 75.1527 31.7291 75.5004 32.1645C75.1527 31.7291 74.8342 31.2987 74.5391 30.8818Z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0957 12.6556L82.1216 22.778V22.7801L87.0944 24.338L92.3431 25.9794L82.0957 12.6556Z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1216 22.7799L87.094 24.3378L82.1216 22.7799Z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0918 12.6559H82.0964V12.6544H82.0918V12.6559Z",
    fill: "#7CBC56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6425 0.182983C79.1793 0.260543 78.7108 0.365501 78.2514 0.497858C75.8843 1.1744 73.7639 2.51482 72.1162 4.37499C71.8926 4.62832 71.6731 4.89514 71.4658 5.16828L71.401 5.25891C71.3613 5.31202 71.3249 5.36682 71.2856 5.41951L82.0948 12.6545L79.6425 0.182983Z",
    fill: "#29A5BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1394 28.6556L71.7654 25.9807L62.7616 20.9279C61.0867 23.9983 60.9396 26.7841 61.1394 28.6556Z",
    fill: "#73B158"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5991 17.3183L94.6017 17.3218L94.5991 17.3183Z",
    fill: "#7CBC56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1443 28.717L61.1564 28.8228L61.1794 28.9518C61.857 32.9688 63.9737 35.425 65.4341 36.6875L71.7666 25.9809L61.1401 28.6554C61.1401 28.6752 61.1443 28.6972 61.1443 28.717Z",
    fill: "#68A855"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8737 37.0498C65.8992 37.0683 65.9259 37.0882 65.9476 37.1088L66.0083 37.1543C68.1484 38.7591 70.2065 39.7914 73.8334 39.9831C74.0441 39.9949 74.2568 40 74.47 40C74.8341 40 75.2056 39.9831 75.5722 39.9519C74.6008 36.3615 71.9236 26.4908 71.7656 25.9845V25.9807L65.4331 36.6877C65.5882 36.8218 65.7353 36.9423 65.8737 37.0498Z",
    fill: "#5B9E54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5722 39.9518L75.576 39.9539C75.6257 39.9485 75.678 39.9451 75.7298 39.94L75.8297 39.9299C75.8744 39.9253 75.9183 39.9206 75.9631 39.9156C78.2089 39.6521 80.038 38.8639 81.2548 38.3378C81.5465 38.2118 81.8028 38.1009 82.0163 38.0187C79.5452 36.5089 77.569 34.6369 76.0391 32.8248V32.8227C75.8519 32.6027 75.6751 32.3826 75.5008 32.166C75.153 31.7288 74.8341 31.2989 74.5394 30.8816C74.391 30.6729 74.2501 30.4677 74.1156 30.2658C73.9772 30.0643 73.8497 29.867 73.7285 29.6735C73.5437 29.3839 73.374 29.1045 73.2165 28.8381C73.1111 28.6606 73.0121 28.4886 72.9201 28.3225C72.6877 27.9111 72.4808 27.5436 72.3333 27.2173C71.7656 25.9861 71.7719 26.0008 71.7656 25.9806",
    fill: "#5A9252"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.352 2.44534C88.1545 1.57954 86.8374 0.932508 85.443 0.522371C84.4126 0.169981 83.3459 -0.00242021 82.2726 0.00938232L82.2099 0.00769624C81.4027 -0.020967 80.5818 0.0304583 79.7642 0.161551C79.7253 0.168295 79.686 0.176304 79.6426 0.183048L82.0916 12.6545L89.5238 2.57432C89.4674 2.53133 89.4122 2.48707 89.352 2.44534Z",
    fill: "#1E98B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3296 9.66507C94.1282 8.91392 93.854 8.17036 93.5146 7.45209C92.8755 6.10661 92.024 4.8901 90.977 3.83589C90.5285 3.38402 90.039 2.96039 89.524 2.57428L82.0918 12.6545H82.0956L94.3417 9.71143L94.3296 9.66507Z",
    fill: "#218DA5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8349 14.4496C94.8349 14.5044 94.8315 14.5609 94.8315 14.6157C94.8315 14.5575 94.8349 14.5027 94.8349 14.4496Z",
    fill: "#7CBC56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1221 22.7779C82.1154 22.78 82.0866 22.79 82.0728 22.795C82.0886 22.79 82.1058 22.7854 82.1221 22.78V22.7779Z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1218 22.7799C82.0921 22.7883 82.0787 22.793 82.0724 22.7951C82.0653 22.7963 82.0628 22.798 82.0724 22.7951C81.5508 22.9506 81.4358 22.9881 71.7661 25.9809L92.3428 25.9797L87.0941 24.3378L82.1218 22.7799Z",
    fill: "#95C65B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0728 22.795C82.079 22.7929 82.0958 22.7879 82.1221 22.78C82.1058 22.7854 82.0886 22.79 82.0728 22.795Z",
    fill: "#7CBC56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8668 15.0988C68.8572 15.1038 68.8475 15.1084 68.8379 15.1135C66.2694 16.4261 64.1949 18.3423 62.9882 20.5275L62.9719 20.5574C62.8996 20.6813 62.8298 20.8057 62.7612 20.9296L71.7655 25.9807L68.8668 15.0988Z",
    fill: "#83BD5C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.095 12.6544L71.2858 5.41943C69.7857 7.50974 68.9359 9.96762 68.8306 12.5431C68.8306 12.5553 68.7637 13.5244 68.8632 15.0836C68.8632 15.0887 68.8632 15.092 68.867 15.0971C69.1328 14.9635 69.3986 14.8357 69.6607 14.7228V14.7164V14.7228C71.5517 13.9054 73.3566 13.392 75.0766 13.078C75.2843 13.0396 75.4941 13.0051 75.7006 12.9718C76.43 12.8592 77.1644 12.7749 77.8972 12.7159C79.3313 12.6013 80.7884 12.6278 82.095 12.6556V12.6544Z",
    fill: "#25B3C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1218 22.7778L82.0958 12.6572L71.7661 25.9809C81.4358 22.9882 81.5508 22.9485 82.0724 22.7951C82.0427 22.8035 82.1151 22.7799 82.1218 22.7778Z",
    fill: "#9EC95B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1218 22.7778L82.0957 12.6555V12.6571L82.1218 22.7778Z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7659 25.9808L82.0918 12.6574V12.6557C80.7889 12.6275 79.3318 12.6014 77.8973 12.7156C77.165 12.775 76.4306 12.8593 75.7012 12.9719C75.4947 13.0052 75.2849 13.0398 75.0771 13.0781C73.3571 13.3921 71.5523 13.9056 69.6613 14.7229V14.7161V14.7229C69.3988 14.8358 69.1334 14.9631 68.8671 15.0972H68.8638L68.8671 15.0989L71.7659 25.9808Z",
    fill: "#91C45A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7285 29.6736C73.8501 29.8671 73.9772 30.0643 74.1156 30.2658C73.9772 30.0643 73.8501 29.8671 73.7285 29.6736Z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9204 28.3226C73.0128 28.4887 73.1118 28.6607 73.2168 28.8381C73.1118 28.6607 73.0128 28.4887 72.9204 28.3226Z",
    fill: "#7CBC56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2163 28.838C73.3739 29.1044 73.544 29.3839 73.7283 29.6735C73.544 29.3839 73.3739 29.1044 73.2163 28.838Z",
    fill: "#7CBC56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.333 27.2173C72.4902 27.5369 72.6875 27.9112 72.9199 28.3226C72.6875 27.9112 72.4902 27.5369 72.333 27.2173Z",
    fill: "#7CBC56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3333 27.2173C71.9562 26.4658 71.7757 26.0042 71.7656 25.9861C71.7757 26.0042 71.9562 26.4658 72.3333 27.2173Z",
    fill: "#7CBC56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3427 25.9796C91.0824 26.4875 89.8117 27.009 88.5461 27.5333C86.6413 28.3216 84.7307 29.1241 82.8305 29.928C81.5636 30.465 80.3038 31.0024 79.0494 31.5386C78.422 31.805 77.7988 32.0714 77.1785 32.3382C77.1752 32.3399 77.1722 32.3399 77.1685 32.3412L76.0391 32.8247C77.5693 34.6368 79.5451 36.5075 82.0167 38.019C83.0203 38.6108 84.3269 39.1006 86.2212 39.598L86.3395 39.6292C86.3429 39.6292 86.3458 39.6309 86.3496 39.6309L86.5264 39.6672C86.5527 39.6718 86.5005 39.6621 86.5264 39.6672L87.5993 37.1478L92.3427 25.9796Z",
    fill: "#83BD5C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8301 29.928C84.7302 29.1242 86.6409 28.3212 88.546 27.533C86.6409 28.3212 84.7302 29.1242 82.8301 29.928Z",
    fill: "#7CBC56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7656 25.9808V25.9863C71.7752 26.0061 71.9562 26.4656 72.3333 27.2176C72.4904 27.5366 72.6877 27.911 72.9201 28.3228C73.0121 28.4884 73.1111 28.6604 73.2165 28.8379C73.374 29.1043 73.5437 29.3837 73.7285 29.6737C73.8497 29.8672 73.9772 30.0645 74.1155 30.266C74.2501 30.4679 74.391 30.6732 74.5394 30.8818C74.8341 31.2987 75.153 31.7291 75.5008 32.1662C75.6717 32.3828 75.8519 32.6029 76.0391 32.8225C76.4136 32.664 76.7907 32.5021 77.1685 32.3411C77.1723 32.3398 77.1752 32.3398 77.1781 32.3382C77.7984 32.0713 78.4217 31.8049 79.0491 31.539C80.3039 31.0024 81.5637 30.4662 82.8302 29.9279C84.7308 29.1241 86.641 28.3215 88.5461 27.5333C89.8114 27.0089 91.0825 26.4875 92.3427 25.9796L71.7656 25.9808Z",
    fill: "#91C45A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7331 11.9558C94.6729 11.2426 94.5487 10.5227 94.369 9.8141L94.3414 9.71167L82.0952 12.6543V12.6556L94.5989 17.3184L94.6014 17.3213C94.6281 17.0613 94.6536 16.8218 94.6837 16.5786C94.7494 16.0505 94.8091 15.2142 94.8309 14.6156C94.8309 14.5608 94.8342 14.5043 94.8342 14.4495C94.8539 13.5825 94.8175 12.7466 94.7331 11.9558Z",
    fill: "#20839F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.469 26.1648C102.374 24.9251 102.132 23.7331 101.755 22.6177L92.3423 25.9798L102.082 30.1617C102.325 29.1601 102.591 27.7438 102.469 26.1648Z",
    fill: "#5B9E54"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.082 30.1619L92.3428 25.9796L97.1388 37.519C100.553 35.0675 101.633 31.7624 101.645 31.7257C101.778 31.2953 101.882 30.9261 101.974 30.5754H101.977L102.011 30.4413C102.017 30.4152 102.026 30.387 102.033 30.3604L102.036 30.3444C102.049 30.2841 102.066 30.2234 102.082 30.1619Z",
    fill: "#68A855"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0957 12.6556L92.3431 25.9794C92.356 25.9516 93.5966 23.7635 94.5994 17.3197L82.0957 12.6556Z",
    fill: "#267491"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.689 22.4226C100.504 19.19 98.2974 17.06 96.6798 15.9413C95.9136 15.4165 95.2612 15.0755 94.8219 14.8787C94.8256 14.791 94.8285 14.7033 94.831 14.6157C94.8093 15.2142 94.7495 16.0505 94.6839 16.5787C94.6534 16.8219 94.6246 17.06 94.5991 17.3201C93.5963 23.7635 92.3557 25.9528 92.3428 25.9794L101.755 22.6178C101.732 22.5537 101.712 22.4871 101.689 22.4226Z",
    fill: "#5A9252"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1661 19.9565L27.1934 19.9552C26.3508 19.9552 25.5574 19.6235 24.9601 19.0203C24.3628 18.4179 24.0343 17.6175 24.0347 16.7681C24.0351 15.9179 24.3641 15.1179 24.9618 14.5155C25.5595 13.9132 26.352 13.5819 27.1947 13.5819H27.1955L30.1687 13.5827L30.1661 19.9565ZM46.8781 10.5461H37.0884C37.0976 10.8972 37.144 11.6054 37.3543 12.2604C37.6372 13.1405 38.1054 13.5869 38.7466 13.5873L46.8769 13.5899C47.7195 13.5899 48.5129 13.9224 49.1102 14.5248C49.7075 15.128 50.0364 15.9276 50.036 16.7778C50.0356 17.628 49.7062 18.4276 49.1085 19.0304C48.5112 19.6319 47.7178 19.9637 46.8756 19.9637H46.8748L33.1765 19.9577L33.1798 10.5461H27.1968H27.1947C23.7931 10.5461 21.0256 13.3357 21.0239 16.7669C21.0227 20.1976 23.7902 22.9897 27.1922 22.991L30.1653 22.9923L30.1649 23.8045C30.1645 25.2103 29.0292 26.3539 27.6352 26.3539H27.6344H23.1937H23.1929C21.6517 26.3539 21.5314 28.3464 21.5309 28.9572V29.4541H27.6331H27.6352C30.689 29.4541 33.174 26.9208 33.1752 23.8058V22.9931L33.5886 22.9939L46.8731 22.9994H46.8756C50.2772 22.9994 53.0451 20.2098 53.0463 16.7795C53.0476 13.3433 50.2805 10.5473 46.8781 10.5461Z",
    fill: "#000105"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9526 29.4542H37.3798C37.6444 29.4542 39.963 29.4058 39.963 27.7146V25.8751H36.9526V29.4542Z",
    fill: "#000105"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4312 12.2259V29.4542H15.8588C16.4648 29.4542 18.4415 29.3332 18.4415 27.7787V10.5461H18.0143C17.4082 10.5461 15.4312 10.6671 15.4312 12.2259Z",
    fill: "#000105"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83867 12.2259V23.2301C9.83867 24.9874 8.42169 26.418 6.67952 26.4184H6.67827C5.83603 26.4184 5.0431 26.0871 4.4458 25.4848C3.84766 24.882 3.51829 24.0824 3.51829 23.2322L3.51578 21.6325C3.51494 20.0792 1.53703 19.9582 0.930945 19.9582H0.5V23.2339C0.501254 26.6642 3.27293 29.4542 6.67869 29.4542H6.6812C10.0832 29.4525 12.8503 26.66 12.849 23.2292V10.5461H12.4214C11.8153 10.5461 9.83867 10.6675 9.83867 12.2259Z",
    fill: "#000105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightArabicLogo);
export default __webpack_public_path__ + "static/media/lightArabicLogo.c82bf6974f2120ea4e5328ca6fe19584.svg";
export { ForwardRef as ReactComponent };